import React, { useState } from "react";
import "./Gallery.css";
import galleryConfig from "../../config/gallery.json"






const Gallery = () => {
  const pic1 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo1.jpg";
  const pic2 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo2.jpg";
  const pic3 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo3.jpg";
  const pic4 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo4.jpg"
  const pic5 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo5.jpg";
  const pic6 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo6.jpg";
  const pic7 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo7.jpg"
  const pic8 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo8.jpg";
  const pic9 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo9.jpg";
  const pic10 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo10.jpg";
  const pic11 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo11.jpg";
  const pic12 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo12.jpg";
  const pic13 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo13.jpg";
  const pic14 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo14.jpg";
  const pic15 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo15.jpg";
  const pic16 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo16.jpg";
  const pic17 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo17.jpg";
  const pic18 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo18.jpg";
  const pic19 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo19.jpg";
  const pic20 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo20.jpg";
  const pic21 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo21.jpg";
  const pic22 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo22.jpg";
  const pic23 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo23.jpg";
  const pic24 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo24.jpg";
  const pic25 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo25.jpg";
  const pic26 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo26.jpg";
  const pic27 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo27.jpg";
  const pic28 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo28.jpeg";
  const pic29 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo29.jpeg";
  const pic30 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo30.jpeg";
  const pic31 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo31.jpeg";
  // const pic32 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo32.jpeg";
  const pic33 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo33.jpeg";
  const pic34 ="https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo34.jpeg";
  

  // Define the images array locally
const galleryImages = [
  { thumbnail: pic1, full: pic1 },
  { thumbnail: pic2, full: pic2 },
  { thumbnail: pic3, full: pic3 },
  { thumbnail: pic4, full: pic4 },
  { thumbnail: pic5, full: pic5 },
  { thumbnail: pic6, full: pic6 },
  { thumbnail: pic7, full: pic7 },
  { thumbnail: pic8, full: pic8 },
  { thumbnail: pic9, full: pic9 },
  { thumbnail: pic10, full: pic10 },
  { thumbnail: pic11, full: pic11 },
  { thumbnail: pic12, full: pic12 },
  { thumbnail: pic13, full: pic13 },
  { thumbnail: pic14, full: pic14 },
  { thumbnail: pic15, full: pic15 },
  { thumbnail: pic16, full: pic16 },
  { thumbnail: pic17, full: pic17 },
  { thumbnail: pic18, full: pic18 },
  { thumbnail: pic19, full: pic19 },
  { thumbnail: pic20, full: pic20 },
  { thumbnail: pic21, full: pic21 },
  { thumbnail: pic22, full: pic22 },
  { thumbnail: pic23, full: pic23 },
  { thumbnail: pic24, full: pic24 },
  { thumbnail: pic25, full: pic25 },
  { thumbnail: pic26, full: pic26 },
  { thumbnail: pic27, full: pic27 },
  { thumbnail: pic28, full: pic28 },
  { thumbnail: pic29, full: pic29 },
  { thumbnail: pic30, full: pic30 },
  { thumbnail: pic31, full: pic31 },
  // { thumbnail: pic32, full: pic32 },
  { thumbnail: pic33, full: pic33 },
  { thumbnail: pic34, full: pic34 },
];

  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleImageClick = (index) => {
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  const showNextImage = () => {
    setSelectedIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
  };

  const showPreviousImage = () => {
    setSelectedIndex(
      (prevIndex) => (prevIndex - 1 + galleryImages.length) % galleryImages.length
    );
  };

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <h3 className="gallery-small-title">{galleryConfig.title}</h3>
        <h1 className="gallery-main-title">{galleryConfig.mainTitle}</h1>
        <p className="section-subtitle">{galleryConfig.subTitle}</p>
        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div className="gallery-card" key={index}>
              <img
                src={image.thumbnail}
                alt={`Thumbnail ${index + 1}`}
                className="thumbnail"
                onClick={() => handleImageClick(index)}
              />
            </div>
          ))}
        </div>
      </div>

      {selectedIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="arrow left-arrow" onClick={showPreviousImage}>
              &#8249;
            </button>
            <img
              src={galleryImages[selectedIndex].full}
              alt={`Full-size ${selectedIndex + 1}`}
              className="full-image"
            />
            <button className="arrow right-arrow" onClick={showNextImage}>
              &#8250;
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
